export function getCurrentUserOrg(currentUserDetails) {
  return {
    Guid: currentUserDetails?.OrgGuid,
    Id: currentUserDetails?.OrgId,
    Name: currentUserDetails?.OrgName,
  };
}
